// @ngInject
function AutoMonthMultiplierDialogService($uibModal, ProductsApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog(articleId) {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'AutoMonthMultiplierDialogController as vm',
            templateUrl: 'main/stocklogistics/orderingpoints/autoMonthMultiplierDialog.tpl.html',
            size: 'lg'
        };


        modalDefaults.resolve = {
            articleId: function () {
                return articleId;
            },
            autoMonthMultipliers: function () {
                return ProductsApiService.ReadMultipliersToEdit(articleId);
            }, 
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function AutoMonthMultiplierDialogController($uibModalInstance, $rootScope, articleId, autoMonthMultipliers, ProductsApiService, loadSpinnerService, confirmationDialogService, ToasterService, $translate) {
    var vm = this;

    vm.selectedAutoMonthMultiplier = filterSelectedMultiplier(autoMonthMultipliers);
    vm.autoMonthMultipliers = angular.copy(autoMonthMultipliers);
    vm.closeModal = closeModal;
    vm.deleteSelected = deleteSelected;
    vm.createNewToggle = createNewToggle;
    vm.create = create;
    vm.saveOnChange = saveOnChange;
    vm.ongoingRequest = false;
    vm.createMode = false;
    vm.enableChangesSavedNotification = false;
    vm.fields = translateMonth();

    vm.allMonthsMultiplier = 1;
    
    vm.handleConvertValue = handleConvertValue;
    vm.handleConvertValueAllMonths = handleConvertValueAllMonths;
    vm.updateOnAllMonths = updateOnAllMonths;

    function translateMonth(){
        var months = $translate.instant('common.months.short').toUpperCase().split(',');
        if (months.length < 12) {
            months = ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'];
        }
        var fullMonthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months.map(function(monthAbbreviation, index) {
            return { abbreviation: monthAbbreviation, full: fullMonthNames[index] };
        });
    }

    function createNewToggle(){
        vm.createMode = true;
        vm.selectedAutoMonthMultiplier = {
            name: "",
            january: 0,
            february: 0,
            march: 0,
            april: 0,
            may: 0,
            june: 0,
            july: 0,
            august: 0,
            september: 0,
            october: 0,
            november: 0,
            december: 0,
        };

        document.getElementById("nameInput").focus();
    }

    function create(){
        vm.ongoingRequest = true
        loadSpinnerService.start('mainSpinner');
        ProductsApiService.createMonthMultiplier(vm.selectedAutoMonthMultiplier).then(function() {
            resetAutoMonthMultipliers();
            ToasterService.showSuccess($translate.instant('common.created'), $translate.instant('article.autoOrderCurve'));
            vm.createMode = false;
        }, function(error) {
            var message = error.message + '\n';
            _.forEach(error.errors, function(err) {
                message += err.message + '\n';
            });
            ToasterService.showError(message, $translate.instant('common.error'));
            loadSpinnerService.stop('mainSpinner');
            vm.ongoingRequest = false
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
            vm.ongoingRequest = false
        });
    }

    function resetAutoMonthMultipliers(){
        ProductsApiService.ReadMultipliersToEdit(articleId).then(function(response) {
            vm.autoMonthMultipliers = sortAutoMonthMultipliers(angular.copy(response), vm.selectedAutoMonthMultiplier);
            vm.selectedAutoMonthMultiplier = vm.autoMonthMultipliers.find(x => x.name === vm.selectedAutoMonthMultiplier.name);
        }, function(error){
            console.log(error)
        })
    }

    function filterSelectedMultiplier(autoMonthMultipliers) {
        if (autoMonthMultipliers && autoMonthMultipliers.length > 0) {
            return autoMonthMultipliers.find(x => x.isArticlesMultiplier);
        } else {
            return null;
        }
    }

    function deleteSelected(){
        var affectedArticleNames = vm.selectedAutoMonthMultiplier.articleNamesWithMultiplier.join('<br>');
        var confirmationMessage = $translate.instant("article.confirmDeleteCurve") + '<br/>';

        if (affectedArticleNames) {
            confirmationMessage += '<strong>' + $translate.instant("article.affectedArticles") + '</strong><br>' + affectedArticleNames;
        }

        confirmationDialogService.showDialog('<div>' + confirmationMessage + '</div>').then(function (result) {
            if (result === true) {
                vm.ongoingRequest = true;
                loadSpinnerService.start("mainSpinner");
                ProductsApiService.deleteMonthMultiplier(vm.selectedAutoMonthMultiplier.id).then(function() {
                    ToasterService.showSuccess($translate.instant('common.wasDeleted'), $translate.instant('article.autoOrderCurve'));
                    $uibModalInstance.close(vm.selectedAutoMonthMultiplier);
                    $rootScope.$emit('multiplierModalClosed', vm.selectedAutoMonthMultiplier);
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, $translate.instant('common.error'));
                    vm.ongoingRequest = false
                    loadSpinnerService.stop("mainSpinner");
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                    vm.ongoingRequest = false;
                });
            }
        });
    }

    function closeModal() {
        if(vm.createMode) {
            $uibModalInstance.close(vm.selectedAutoMonthMultiplier);
            return;
        }

        ProductsApiService.changeMultiplierOnArticle(articleId, vm.selectedAutoMonthMultiplier).then(function() {
            ToasterService.showSuccess($translate.instant('common.wasSaved'), $translate.instant('article.autoOrderCurve'));
        }, function(error) {
            var message = error.message + '\n';
            _.forEach(error.errors, function(err) {
                message += err.message + '\n';
            });
            ToasterService.showError(message, $translate.instant('common.error'));
            vm.ongoingRequest = false
            loadSpinnerService.stop("mainSpinner");
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
            vm.ongoingRequest = false;
            $uibModalInstance.close(vm.selectedAutoMonthMultiplier);
            $rootScope.$emit('multiplierModalClosed', vm.selectedAutoMonthMultiplier);
        });
    }

    function updateNameProp() {
        const updatedMultiplierIndex = vm.autoMonthMultipliers.findIndex(multiplier => multiplier.id === vm.selectedAutoMonthMultiplier.id);
        if (updatedMultiplierIndex !== -1) {
            const updatedMultiplier = angular.copy(vm.autoMonthMultipliers[updatedMultiplierIndex]);
            updatedMultiplier.name = vm.selectedAutoMonthMultiplier.name;
            vm.autoMonthMultipliers[updatedMultiplierIndex] = updatedMultiplier;
        }
    }

    function sortAutoMonthMultipliers(autoMonthMultipliers, selectedMultiplier) {
        if (selectedMultiplier !== null) {
            return autoMonthMultipliers.slice().sort(function(a, b) {
                if (a.name === selectedMultiplier.name) {
                    return -1;
                } else if (b.name === selectedMultiplier.name) {
                    return 1;
                }
                return 0;
            });
        } else {
            return autoMonthMultipliers.slice(); 
        }
    }

    function handleConvertValue(fieldName) {
        if(angular.isString(vm.selectedAutoMonthMultiplier[fieldName])){
            vm.selectedAutoMonthMultiplier[fieldName] = parseFloat(vm.selectedAutoMonthMultiplier[fieldName]);
        }
    }
    function handleNegativeValue(fieldName){
        if(vm.selectedAutoMonthMultiplier[fieldName] < 0){
            vm.selectedAutoMonthMultiplier[fieldName] = 0
        }
    }
    function handelUndefinedValue(fieldName){
        if(!vm.selectedAutoMonthMultiplier[fieldName]){
            vm.selectedAutoMonthMultiplier[fieldName] = 0;
        }
    }

    function handleConvertValueAllMonths(){
        if(angular.isString(vm.allMonthsMultiplier)){
            vm.allMonthsMultiplier = parseFloat(vm.allMonthsMultiplier);
        }
    }

    function updateOnAllMonths(){

        var confirmationMessage =   '<h4>' + $translate.instant('article.confirmUpdateEntireCurve') + '</h4>' +
                                    '<div><b>' + vm.allMonthsMultiplier.toString().replace('.', ',') + ' </b>' + $translate.instant('article.willBeSetOnAllMonths') + '.</div>'
                                    
        confirmationDialogService.showDialog(confirmationMessage).then(function (result) {
            if (result === true) {
                _.forEach(vm.fields, function(field){
                    vm.selectedAutoMonthMultiplier[field.full.toLowerCase()] = vm.allMonthsMultiplier; 
                })
                
        
                saveOnChange();
            }

            vm.allMonthsMultiplier = 1;
        });
    }

    function saveOnChange() {
        _.forEach(vm.fields, function(field){
            handleConvertValue(field.full.toLowerCase());
            handelUndefinedValue(field.full.toLowerCase());
            handleNegativeValue(field.full.toLowerCase());
        })

        if(vm.createMode || !vm.selectedAutoMonthMultiplier.name) return
        updateNameProp();
        vm.enableChangesSavedNotification = true;
        vm.ongoingRequest = true

        ProductsApiService.updateMonthMultiplier(vm.selectedAutoMonthMultiplier).then(function() {
            resetAutoMonthMultipliers();
            vm.allMonthsMultiplier = 1;
        }, function(error) {
            console.log(error);
            var message = error.message + '\n';
            _.forEach(error.errors, function(err) {
                message += err.message + '\n';
            });
            ToasterService.showError(message, $translate.instant('common.error'));
            vm.ongoingRequest = false
        }).finally(function() {
            vm.ongoingRequest = false
        });
    }
}

angular
    .module('stocklogistics.orderingpoints.autoMonthMultiplierDialog', [])
    .service('AutoMonthMultiplierDialogService', AutoMonthMultiplierDialogService)
    .controller('AutoMonthMultiplierDialogController', AutoMonthMultiplierDialogController);